import { Factory } from "../../core/factory";

import { ElementHighlightByGroup } from "./element-highlight-by-group";

const type = "element-highlight-by-key";

export class ElementHighlightByKey extends ElementHighlightByGroup {
    constructor() {
        super(...arguments), this.type = type;
    }
    _getHightlightKey(g) {
        var _a;
        return null === (_a = g.context) || void 0 === _a ? void 0 : _a.key;
    }
}

ElementHighlightByKey.type = type;

export const registerElementHighlightByKey = () => {
    Factory.registerInteractionTrigger(type, ElementHighlightByKey);
};
//# sourceMappingURL=element-highlight-by-key.js.map
